/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum UserOrderingFilterEnum {
  /**
   * dátumu registrácie
   */
  DATE_JOINED_DESC = "DATE_JOINED_DESC",
  /**
   * dátumu prihlásenia
   */
  LAST_LOGIN_DESC = "LAST_LOGIN_DESC",
  /**
   * obľúbenosti
   */
  STATS__FAVORITED_COUNT_DESC = "STATS__FAVORITED_COUNT_DESC",
}